// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"487":"3c529ec4","990":"dd774ec3"}[chunkId] + ".chunk.css";
};